import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage selector="tabs" mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`client.capture({
    distinctId: 'distinct_id',
    event: 'order_created',
    properties: {
        order_id: '#0054',
        subtotal: 3599,
        customer_name: 'Max Hedgehog',
    },
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`posthog.capture(
    'distinct_id',
    'order_created',
    {
        'order_id': '#0054',
        'subtotal': 3599,
        'customer_name': 'Max Hedgehog',
    }
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::capture(array(
  'distinctId' => 'distinct_id',
  'event' => 'order_created',
  'properties' => array(
    'order_id' => '#0054'
    'subtotal' => 3599,
    'customer_name' => 'Max Hedgehog'
  )
));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ruby"
        }}>{`posthog.capture({
    distinct_id: 'distinct_id',
    event: 'order_created',
    properties: {
        order_id: '#0054',
        subtotal: 3599,
        customer_name: 'Max Hedgehog'
    }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`client.Enqueue(posthog.Capture{
  DistinctId: "distinct_id",
  Event:      "order_created",
  Properties: posthog.NewProperties().
    Set("order_id", "#0054").
    Set("subtotal", 3599).
    Set("customer_name", "Max Hedgehog"),
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-java"
        }}>{`posthog.capture(
  "distinct id",
  "movie_played",
  new HashMap<String, Object>() {
    {
      put("order_id", "#0054");
      put("subtotal", 3599);
      put("customer_name", "Max Hedgehog");
    }
  }
);
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      